import { PayFileStatus, PayFileType } from "@/graphql/codegen/graphql"

export const PAY_FILE_STATUS_TO_LABEL: Record<PayFileStatus, string> = {
  [PayFileStatus.Pending]: "Pending",
  [PayFileStatus.Approved]: "Approved",
  [PayFileStatus.Processing]: "Processing",
  [PayFileStatus.Cancelled]: "Cancelled",
  [PayFileStatus.Sent]: "Sent",
} as const

export const PAY_FILE_STATUS_TO_CHIP_CLASS_NAME: Record<PayFileStatus, string> = {
  [PayFileStatus.Pending]: "bg-tertiary-orange-300 text-gray-900",
  [PayFileStatus.Approved]: "bg-primary-200 text-gray-900",
  [PayFileStatus.Processing]: "bg-tertiary-yellow-300 text-gray-900",
  [PayFileStatus.Cancelled]: "bg-secondary-200 text-gray-900",
  [PayFileStatus.Sent]: "bg-tertiary-green-300 text-gray-900",
} as const

export const PAY_FILE_TYPE_TO_LABEL: Record<PayFileType, string> = {
  [PayFileType.AchCkVcc]: "ACH / Check / VCC",
} as const

export const PAY_FILE_APPROVED_WARNING_TOOLTIP =
  "An error occurred before this pay file could be sent. Please remove approval and try again."

// Approving only flips the pay file to Processing; the Huntington file is generated and delivered
// afterwards, so the outcome is polled for.
export const PAY_FILE_PROCESSING_POLL_INTERVAL_MS = 2000

export const PAY_FILE_PROCESSING_POLL_TIMEOUT_MS = 120_000

// Matches the backend's `requiredComment` cap on every pay file comment mutation.
export const PAY_FILE_COMMENT_MAX_LENGTH = 2000

export const PAY_FILE_TO_DATE_PAST_ERROR = "To Scheduled Pay Date must be today or a future date"

export const PAY_FILE_TO_DATE_REQUIRED_ERROR = "To Scheduled Pay Date is required"

// The design shows Pending, Approved, Sent, Cancelled — a different order than the GraphQL enum
// declaration, so the list is explicit rather than derived from Object.values(PayFileStatus).
// AK-6851: Processing sits after Approved because it is the in-flight step between Approved and Sent, and
// it has to be selectable for the default view (which includes it) to be shown and removed like any filter.
export const PAY_FILE_STATUS_FILTER_ORDER: PayFileStatus[] = [
  PayFileStatus.Pending,
  PayFileStatus.Approved,
  PayFileStatus.Processing,
  PayFileStatus.Sent,
  PayFileStatus.Cancelled,
]

// AK-6851: the view a user lands on, applied as a real, removable filter in the URL. It includes Processing so a
// file being sent does not drop out of the list mid-flight (AK-5104).
export const PAY_FILE_DEFAULT_STATUSES: PayFileStatus[] = [
  PayFileStatus.Pending,
  PayFileStatus.Approved,
  PayFileStatus.Processing,
]
